/**   
 * 订单管理api 
 */
export default {
/**
   * 订单管理
   */
// projectOrderList: "/store_project_order/select_project_order_platform", //体验项目+正式项目列表
// projectOrderInfo: "/store_project_order/select_project_order_info", //项目详情
reserveOrderList: "/store_project_reservation/project_reservation_list", //预约订单列表
reserveOrderInfo: "/store_project_reservation/project_reservation_info", //预约订单详情
reserveOrderVerification: "/store_project_reservation/verification_appointment", //预约订单核销
technicianConfirmation: "/store_project_reservation/choice_technician", //预约订单核销选择技师提交
projectOrderInfo: "/store_project_order/select_project_order_info", //项目详情
productOrderList: "/shop_order/select_online_orders", //商品订单列表
productOrderInfo: "/shop_order/select_online_orders_info", //商品订单详情
productOrderRefund: "/shop_order/refund_order", //商品订单退款
productOrderDeliver: "/shop_order/deliver_goods", //商品订单发货
productOrderConfirm: "/shop_order/confirm_goods", //商品订单确认发货
productRefundOrderList: "/store_order_refund/select", //售后订单列表
productRefundOrderInfo: "/store_order_refund/get", //售后订单详情
productRefundOrderHandle: "/store_order_refund/refund_order_update_status", //售后订单处理
};